import React from "react";
import "../assets/css/roadmap.css";
import {
	Roadmap1,
	Roadmap2,
	Roadmap3,
	Roadmap4,
	Roadmap5,
} from "../constant/Index";
import { useRoadContentQuery } from "../store/services/RoadMapService";
import { useSiteContentQuery } from "../store/services/SitesettingService";

const RoadMap = () => {
	const { data, isLoading } = useRoadContentQuery();
	const { data: site, isLoading: siteLoading } = useSiteContentQuery();
	let RoadData = data?.response?.data;
	let SiteSetting = site?.response?.data[0];
	return (
		<>
			<section className="road_map">
				<div className="glowing glowing-one">
					<span></span>
				</div>
				<div className="container">
					<div className="heading_wrapper">
						<h4>ROAD MAP ACTIVATIONS </h4>
						<h2>{SiteSetting?.roadmap_title}</h2>
						<p
							dangerouslySetInnerHTML={{
								__html: SiteSetting?.roadmap_description,
							}}
						></p>
					</div>
					<div className="row">
						{RoadData?.map((data, index) => {
							return (
								<div className="col-lg-4" key={index}>
									<div className="map_box map_right">
										<div className="content">
											<h4>{data?.discount}</h4>
											<h5>{data?.title}</h5>
										</div>
										<div className="border-dv"></div>
										<div className="nft-img">
											<figure>
												<img
													src={data?.image_path}
													alt=""
													className="img-fluid"
												/>
											</figure>
										</div>
									</div>
								</div>
							);
						})}
						{/* <div className="col-lg-4">
							<div className="map_box map_right right-top">
								<div className="content">
									<h4>20%</h4>
									<h5>Offer Exclusive deals for NFT holders only</h5>
								</div>
								<div className="border-dv"></div>
								<div className="nft-img">
									<figure>
										<img src={Roadmap4} alt="" className="img-fluid" />
									</figure>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="map_box map_left">
								<div className="content">
									<h4>40%</h4>
									<h5>Unlock Higher Loan Offerings </h5>
								</div>
								<div className="border-dv"></div>
								<div className="nft-img">
									<figure>
										<img src={Roadmap2} alt="" className="img-fluid" />
									</figure>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="map_box map_right">
								<div className="content">
									<h4>50%</h4>
									<h5>Offer loans on NFT Collections</h5>
								</div>
								<div className="border-dv"></div>
								<div className="nft-img">
									<figure>
										<img src={Roadmap5} alt="" className="img-fluid" />
									</figure>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="map_box map_right right-top">
								<div className="content">
									<h4>70%</h4>
									<h5>Create the pool for profit distribution</h5>
								</div>
								<div className="border-dv"></div>
								<div className="nft-img">
									<figure>
										<img src={Roadmap3} alt="" className="img-fluid" />
									</figure>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="map_box map_left">
								<div className="content">
									<h4>100%</h4>
									<h5>Distribute the profit to NFT holders</h5>
								</div>
								<div className="border-dv"></div>
								<div className="nft-img">
									<figure>
										<img src={Roadmap1} alt="" className="img-fluid" />
									</figure>
								</div>
							</div>
						</div> */}
					</div>
				</div>
				<div className="glowing glowing-two">
					<span></span>
				</div>
			</section>
		</>
	);
};

export default RoadMap;
